export default {
  methods: {
    showLoading(target) {
      target.showLoading({
        text: '',
        color: '#fff', // 圈圈颜色
        textColor: '#fff', // 文字颜色
        maskColor: 'transparent',
        lineWidth: 2,
        zlevel: 0
      })
    },
    hideLoading(target) {
      target.hideLoading()
    }
  }
}
